export const CAREER_SETTING = {
                                    texts:{
                                                modal:{
                                                            message:'If you reset the career page all the changes will be lost and reset to default careers page. Are you sure to proceed?',
                                                            button_1: 'Cancel',
                                                            button_2: 'Reset'
                                                      },
                                                
                                          },
                                          tooltip: {
                                                background: "#00325A",
                                                radius: "20",
                                                padding: "8",
                                                placement: "top",
                                                fontSize: "12px",
                                              },
                                          urlRegex: /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i
                              }
